import { ModalAnnulationConfirmationComponent } from './../../../../shared/components/modals/modal-annulation-confirmation/modal-annulation-confirmation.component';
import { SimpleQueryResponse } from './../../../../shared/dtos/simpleQueryResponse';
import { FilterDemandeDTO } from './../../../../shared/dtos/filterDemandeDTO';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ModalUpdateConfirmationComponent } from 'src/app/shared/components/modals/modal-update-confirmation/modal-update-confirmation.component';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { ToastrService } from 'ngx-toastr';
import { DemandeModel } from 'src/app/shared/models/agence-linked/demande/demande.model';
import { RegionService } from 'src/app/shared/services/rsa/region.service';
import { DemandeService } from 'src/app/shared/services/agence-linked/demande.service';
registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-demande-list',
  templateUrl: './demande-list.component.html',
  styleUrls: ['./demande-list.component.scss']
})
export class DemandeListComponent implements OnInit, OnChanges {
  // tslint:disable-next-line: max-line-length
  displayedColumnsDemande: string[] = ['numero','typeDemande', 'utilisateur','region','agence','statut','dModification', 'retour'];
  // tslint:disable-next-line
  @Input() ifCreateBp: boolean = false;
  @Input() ifListAValide: boolean = false;
  @Input() filtreData: FilterDemandeDTO;
  @Input() simpleQueryDemandeResponse: SimpleQueryResponse<DemandeModel> = null;
  matDataSourceDemande: MatTableDataSource<DemandeModel> = new MatTableDataSource<DemandeModel>();
  @Output() selectedRowsEmit = new EventEmitter<DemandeModel[]>();
  selectedDemandes: DemandeModel[] = [];
  selection = new SelectionModel<DemandeModel>(true, []);
  length: number;
  pageIndex: number;
  pageSize = 25;
  sortState: Sort = { active: 'dDemande', direction: 'asc' };
  dataSource: any[];
  users: UtilisateurModel[] = [];
  //public FlagEnum = NTHFlag;
  public width = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @Input() datasource: DemandeModel[];


  constructor(
    private triTabService: TrieTabService,
    public dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private demandeService: DemandeService,
    private regionService: RegionService,
    private userService: UserService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line: max-line-length
    if (changes.datasource && changes.datasource.currentValue && changes.simpleQueryDemandeResponse && changes.simpleQueryDemandeResponse.currentValue) {
      this.dataSource = changes.datasource.currentValue.slice();
      this.matDataSourceDemande = new MatTableDataSource(this.dataSource);
      this.length = this.simpleQueryDemandeResponse.count;
      this.pageIndex = this.simpleQueryDemandeResponse.pageNumber;
      this.pageSize = this.simpleQueryDemandeResponse.pageSize;
    }
    this.loadPage();
  }

  ngOnInit(): void {
    this.width = window.innerWidth; 
  }


  changePage(event?: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filtreData.pageNumber = event.pageIndex;
    this.filtreData.pageSize = event.pageSize;
    this.loadPage();
  }

  trieTab(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.filtreData.descending = false;
    } else {
      this.filtreData.descending = true;
    }
    this.sortState = sort;
    this.filtreData.order = sort.active;
    this.loadPage();
  }

  loadPage(): void {
    if(this.filtreData) {
       this.demandeService.getFiltredDemande(this.filtreData).subscribe((data: SimpleQueryResponse<DemandeModel>) => {
    
      this.simpleQueryDemandeResponse = data;
      this.datasource = data.objets;
      this.length = this.simpleQueryDemandeResponse.count;
      this.pageIndex = this.simpleQueryDemandeResponse.pageNumber;
      // tslint:disable-next-line: max-line-length
      const datas = this.datasource.slice();
      this.matDataSourceDemande = new MatTableDataSource(datas.slice(0, this.pageSize));


      this.matDataSourceDemande.data.forEach(row => {
        // Lors du chargement des pages reselectionner les lignes 
        if (this.selectedDemandes.find(line => line.id === row.id)) {
          this.selection.select(row);
        }
      });
    });
    }
   
  }

  editDemande(demande: DemandeModel): void {
    const dialogRef = this.dialog.open(ModalUpdateConfirmationComponent, {
      data: {
        title: 'Action sur la demande ' + demande.code,
        code: demande.code,
        type: 'Demande',
        statut: demande.status,
        message: 'Que souhaitez-vous réaliser sur cette demande ?',
        icone: 'warning_amber',
        iconColor: 'info',
        color: 'accent',
        idAgence: demande.idAgence,
        nivStatus: demande.statusNum,
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        switch (res) {
          case 'Modifier Brouillon': {
            this.router.navigate(['edit-demande/' + demande.id]);
            break;
          }
          case 'Voir': {
            this.router.navigate(['read-demande/' + demande.id]);
            break;
          }
          case 'Valider': {
            this.router.navigate(['validate-demande/' + demande.id]);
            break;
          }
           case 'Traiter': {
             this.router.navigate(['traiter-demande/' + demande.id]);
             break;
           }
          case 'Annuler': {
            const dialogConfirmation = this.dialog.open(ModalAnnulationConfirmationComponent, {
              data: {
                title: 'Annulation de la demande ' + demande.code,
                type: 'Demande',
                statut: demande.status,
                message: 'Souhaitez-vous annuler cette demande? ',
                icone: 'warning',
                iconColor: 'warn',
                color: 'danger',
                idAgence: demande.idAgence,
              }
            });
            return dialogConfirmation.afterClosed().subscribe((resultat) => {
              if (resultat) {
                this.demandeService.cancel(demande).subscribe((otherdemande) =>
                {
                  this.datasource = this.datasource.filter(b => b.id !== otherdemande.id);
                  //if(otherdemande.status !== "Brouillon")
                  //  this.datasource.push(otherdemande);

                  // tslint:disable-next-line: max-line-length
                  const datas = this.datasource.slice();
                  this.matDataSourceDemande = new MatTableDataSource(datas.slice(0, this.pageSize));
                  this.toastr.success('Annulation de la demande ' + demande.code +  ' réussie');

                });
              }
            });
          }
        }
      }
    });
  }

  compareRow(row: DemandeModel): boolean {
    return false;
    /*if (row) {
      const currentDemande = this.selectedDemandes.find(line => line.position === row.position && line.id === row.id);
      if (currentDemande && this.selectedDemandes.length > 0) {
        for (const demande of this.selectedDemandes) {
          if (demande) {
            if (demande.id === currentDemande.id) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    }*/
  }

  reload(): void {
    this.matDataSourceDemande = new MatTableDataSource<DemandeModel>(this.dataSource);
    this.matDataSourceDemande.paginator = this.paginator;
    this.matDataSourceDemande.data.forEach(row => this.selection.select(row));
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {

    if (this.isAllSelected()) {
      this.deleteDemandeRows();
      this.selection.clear();
    }
    else {
      if (this.ifCreateBp) {
        this.matDataSourceDemande.data.forEach(row => {
          // Si on ne trouve pas dans la sélection la ligne, on l'ajoute.
          if (!this.selectedDemandes.find(line => line === row) && !this.isRowDisabled(row)) {
            this.selection.select(row);
            this.setRowToDemandes(row);
          }
        });
      } else {
        this.matDataSourceDemande.data.forEach(row => {
          // Si on ne trouve pas dans la sélection la ligne, on l'ajoute.
          if (!this.selectedDemandes.find(line => line === row)) {
            this.selection.select(row);
            this.setRowToDemandes(row);
          }
        });
      }
    }
    this.selectedRowsEmit.emit(this.selectedDemandes);
  }

  selectRow(row: DemandeModel): void {
    // On passe si la ligne est censée être désactivée
    if (this.ifCreateBp) {
      if (this.isRowDisabled(row)) {
        return;
      }
    }
    this.selection.toggle(row);
    let currentDemande: DemandeModel;
    if (row) {
      currentDemande = this.selectedDemandes.find(model => model === row);
    }
    if (!currentDemande) {
      this.setRowToDemandes(row);
    } else {
      this.deleteDemandeRow(row);
    }
    this.selectedRowsEmit.emit(this.selectedDemandes);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    if (numSelected === 0) {
      return false; // Si il n'y a pas de lignes sélectionnées, on retourne faux ici
    }
    // On compte le nombre de lignes qui ne sont pas désactivées, et on les compare au nb de lignes sélectionnées
    if (this.ifCreateBp) {
      let i = 0;
      for (const row of this.matDataSourceDemande.data) {
        /*if (!this.isRowDisabled(row)) {
          i++;
        }*/
      }
      return numSelected === i;
    }
    return this.length === numSelected;
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: DemandeModel): string {
    if (!row) {
      return `${!this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    //return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  /* Remove all checked items in demandeArray  */
  deleteDemandeRows(): void {
    this.selectedDemandes = [];
  }

  /* Remove item in demandeArray */
  deleteDemandeRow(row: DemandeModel): void {
    this.selectedDemandes.splice(this.selectedDemandes.findIndex(r => r === row), 1);
  }

  /* Add item into demandeArray */
  setRowToDemandes(row: DemandeModel): void {
    this.selectedDemandes.push(row);
  }

  /**
   * Vérifie si une ligne est à desactiver ou non
   * @param row La ligne à tester
   * @returns vrai si la ligne doit être désactivée
   */
  isRowDisabled(row: DemandeModel): boolean {
    return false;
    //return !(this.selectedDemandes.length === 0 || this.selectedDemandes.find(r => r.codeFourn === row.codeFourn && r.codeCa1 === row.codeCa1));
  }

}
